import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * パスワード
 */
export class Password extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Password {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new Password(value);
  }

  /** ラベル */
  static get label(): string {
    return 'パスワード';
  }

  /** ラベル2 */
  static get label2(): string {
    return 'パスワード(8文字以上,アルファベット小文字、大文字、数字を含む)';
  }

  /** タイプ */
  static get type() {
    return 'password';
  }

  /** キー */
  static get key() {
    return 'password';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      /** パターン */
      pattern: {
        /** 値 */
        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,32}$/,
        /** メッセージ */
        message: '8文字以上かつ32文字以下かつアルファベット小文字、大文字、数字は最低でも1つ含む必要があります',
      },
    };
  }
}
